import React from "react";
import PropTypes from "prop-types";

export const RightArrow = ({ color = "#333" }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.51724 7.03454L14.4828 12.0001L9.51724 16.9656"
        stroke="#C6554F"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

RightArrow.propTypes = {
  color: PropTypes.string,
};
